import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { checkInputErrorRequired, useDatePicker, useTimePicker } from '@chilecompra/react-kit'
import { Typography, TimePicker } from '@chilecompra/react-kit/components'
import { features } from '../../config/settings/features'
import { useImperativeFormRef } from './QuoteStepOne.hooks'
import { DatePicker, Grid } from './QuoteStepOne.styles'

/**
 * The ClosingDate's component.
 */
const ClosingDate = props => {
  const { closeDate, formRef, isDownToTiny, minDate, maxDate: inComingMaxDate } = props
  const { authInfo } = useSelector(state => state.authorizationProvider)

  const maxDate = useMemo(
    () => (features['services.use.max.date'] && inComingMaxDate ? inComingMaxDate : undefined),
    [inComingMaxDate, features]
  )
  const {
    error: closingDateError,
    value: closingDateValue,
    onChange: handleClosingDateChange
  } = useDatePicker({
    errorCallbacks: [checkInputErrorRequired()],
    initialValue: closeDate,
    overwriteCallback: () => closeDate
  })
  const {
    error: closingTimeError,
    value: closingTimeValue,
    onChange: handleClosingTimeChange
  } = useTimePicker({
    errorCallbacks: [checkInputErrorRequired()],
    initialValue: closeDate,
    overwriteCallback: () => closeDate
  })

  useImperativeFormRef(formRef, () => ({ closingDateError, closingDateValue, closingTimeError, closingTimeValue }), [
    closingDateError,
    closingDateValue,
    closingTimeError,
    closingTimeValue
  ])

  return (
    <Grid container margin="24px 0 24px">
      <Grid container item sm direction="column" padding="2px 32px 0 0" xs={12}>
        <Typography fontWeight="bold" variant="body2">
          Fecha de cierre
        </Typography>
        <Typography fontWeight="regular" color="black1" variant="body2">
          Te recomendamos seleccionar un día hábil.
        </Typography>
      </Grid>
      <Grid container item sm={8}>
        <Grid item sm={6} padding={isDownToTiny ? '16px 0 0' : '0 16px 0 0'}>
          <DatePicker
            disabled={authInfo.hasObserverRole}
            error={closingDateError}
            format="dd/MM/yyyy"
            label="Fecha"
            minDate={new Date(minDate)}
            maxDate={maxDate}
            value={closingDateValue}
            onChange={handleClosingDateChange}
          />
        </Grid>
        <Grid item padding={isDownToTiny ? '0' : '0 0 0 16px'} sm={6}>
          <TimePicker
            disabled={authInfo.hasObserverRole}
            error={closingTimeError}
            label="Hora"
            onChange={handleClosingTimeChange}
            tiping
            value={closingTimeValue}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

ClosingDate.defaultProps = {
  formRef: {
    current: {}
  },
  isDownToTiny: false
}

ClosingDate.propTypes = {
  closeDate: PropTypes.instanceOf(Date),
  formRef: PropTypes.shape({
    current: PropTypes.shape(Object)
  }),
  isDownToTiny: PropTypes.bool,
  minDate: PropTypes.string,
  maxDate: PropTypes.string
}

export default ClosingDate
